"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsFlightNumberValidator = void 0;
const utils_1 = require("@daytrip/utils");
const class_validator_1 = require("class-validator");
let IsFlightNumberValidator = class IsFlightNumberValidator {
    validate(value) {
        return (0, utils_1.isFlightNumber)(value);
    }
    defaultMessage() {
        return "Flight number is in wrong format.";
    }
};
exports.IsFlightNumberValidator = IsFlightNumberValidator;
exports.IsFlightNumberValidator = IsFlightNumberValidator = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: "isFlightNumber" })
], IsFlightNumberValidator);
//# sourceMappingURL=isFlightNumberValidator.js.map